import { PriceSetting } from "./PriceSetting"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import {
  selectSettings,
  setPriceParams,
  PriceType,
  selectActiveShops,
  updatePricesParams,
  selectFeedShopIdents,
} from "../../app/reducers/settingsReducer"
import s from "./Settings.module.css"
import { Tabs } from "../Tabs/Tabs"
import { TabContent } from "../Tab/TabContent"
import { useNavigateSubTab } from "../../utils/hooks/useNavigateTab"
import { FC, useState } from "react"
import { StorageManager } from "../StorageManager/StorageManager"
import { TokenManager } from "../TokenManager/TokenManager"
import { CardsManagerTabs } from "../CardsManagerTabs/CardsManagerTabs"
import { getMessage } from "../../msgs/msgs"
import { Box } from "@radix-ui/themes"

export const Settings: FC = () => {
  const dispatch = useAppDispatch()
  const settingspriceState = useAppSelector(selectSettings)
  const activeShopsState = useAppSelector(selectActiveShops)
  const feedShopIdents = useAppSelector(selectFeedShopIdents)
  const activeShops = activeShopsState.concat(feedShopIdents as any[])

  const [activeSubTab, navigate] = useNavigateSubTab()
  const [selectedShop, setSelectedShop] = useState<string>(activeShops?.[0])

  return (
    <Box className={`${s.settings}`}>
      <Tabs
        onChange={navigate}
        activeTabIdent={activeSubTab}
        height="calc(-76px + 100vh)"
      >
        <TabContent
          key={`tabcontent-priceParams`}
          name={`Настройка параметров цены`}
          ident={"priceParams"}
        >
          <Tabs
            isVertical
            onChange={(ident) => setSelectedShop(ident)}
            activeTabIdent={selectedShop}
            height="calc(-128px + 100vh)"
          >
            {activeShops.map((shopName) => {
              const priceParams = settingspriceState[shopName]?.price || {}
              const amountParams =
                settingspriceState[shopName]?.amountParams || []
              return (
                <TabContent
                  key={`tabcontent-${shopName}`}
                  name={`Калькулятор для ${getMessage(shopName)}`}
                  ident={shopName}
                >
                  <PriceSetting
                    amountParams={amountParams}
                    {...priceParams}
                    onSave={(
                      args: PriceType,
                      amountParams?: { amount: number; count: number }[],
                    ) =>
                      dispatch(
                        updatePricesParams({
                          shop: shopName,
                          price: args,
                          amountParams,
                        }),
                      )
                    }
                    shop={shopName}
                    onChange={(
                      args: PriceType,
                      amountParams?: { amount: number; count: number }[],
                    ) =>
                      dispatch(
                        setPriceParams({
                          shop: shopName,
                          price: args as any,
                          amountParams,
                        }),
                      )
                    }
                  />
                </TabContent>
              )
            })}
          </Tabs>
        </TabContent>
        <TabContent
          key={`tabcontent-storageManaget`}
          name={`Управление складами`}
          ident={"storageManaget"}
        >
          <StorageManager />
        </TabContent>
        <TabContent
          key={`tabcontent-tokenManager`}
          name={`Управление токенами`}
          ident={"tokenManager"}
        >
          <TokenManager />
        </TabContent>
        <TabContent
          key={`tabcontent-cardsManager`}
          name={`Управление карточками`}
          ident={"cardsManager"}
        >
          <CardsManagerTabs />
        </TabContent>
      </Tabs>
    </Box>
  )
}
